import { useState } from "react";
import {
  firmLogoFillService,
  type FirmLogoFillExportFormat,
  type FirmLogoFillFilter,
} from "../../../api/firmLogoFill.service.js";
import { downloadBlob } from "../../../utils/csvExport.js";

const CSV_BYTE_ORDER_MARK = "\uFEFF";

function exportFileName(date: Date, format: FirmLogoFillExportFormat): string {
  return `firm-logo-copy-${date.toISOString().slice(0, 10)}.${format}`;
}

export function useFirmLogoCopyExport(filter: FirmLogoFillFilter) {
  const [exportingFormat, setExportingFormat] = useState<FirmLogoFillExportFormat | null>(null);
  const [exportError, setExportError] = useState<string | null>(null);

  const downloadExport = async (format: FirmLogoFillExportFormat) => {
    setExportingFormat(format);
    setExportError(null);

    try {
      const file = await firmLogoFillService.exportFile(format, filter);
      const download =
        format === "csv"
          ? new Blob([CSV_BYTE_ORDER_MARK, file], { type: "text/csv;charset=utf-8" })
          : file;
      downloadBlob(download, exportFileName(new Date(), format));
    } catch (downloadError) {
      setExportError(
        downloadError instanceof Error ? downloadError.message : String(downloadError),
      );
    } finally {
      setExportingFormat(null);
    }
  };

  return { exportingFormat, exportError, downloadExport };
}
